import React, { memo, ReactNode, useMemo } from 'react';

import { Permissions, useUser } from '@explorer/stores';

/**
 * PermissionWrapper
 */
export const PermissionWrapper = memo(
  //
  function PermissionWrapper({
    has = [],
    children = null,
    notAllowedComponent = null,
    hasAtLeastOnePermission = false,
  }: PermissionWrapperProps) {
    const { userHasPermissions, userHasSomePermissions } = useUser();

    const allow = useMemo(() => {
      if (hasAtLeastOnePermission) {
        return userHasSomePermissions(has);
      }
      return userHasPermissions(has);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [has, hasAtLeastOnePermission]);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    if (allow) return <>{children}</>;

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{notAllowedComponent}</>;
  },
);

PermissionWrapper.displayName = 'PermissionWrapper';

/**
 * PermissionWrapperProps
 */
export interface PermissionWrapperProps {
  readonly has: Permissions[];
  readonly hasAtLeastOnePermission?: boolean;
  readonly children: ReactNode;
  readonly notAllowedComponent?: ReactNode;
}
